import { buildCardField } from '@shared/data/cards/CardField';
import { FieldRecord } from '@shared/scenes/entity/types';
import { User } from '@shared/types/user';

interface BuildFieldRecordProps {
  entity: MBAPI.WorkflowEntity;
  components: MBAPI.WorkflowTemplate_components[];
  refs: MBAPI.ListWorkflowEntitiesQuery_list_refs;
  defaultData?: any;
  currentUser?: User;
}

export function buildFieldRecord({
  entity,
  components,
  refs,
  defaultData,
  currentUser,
}: BuildFieldRecordProps): FieldRecord {
  return components.reduce((record, component) => {
    record[component.id] = buildCardField({
      entity,
      component,
      refs,
      defaultData,
      currentUser,
    });
    return record;
  }, {});
}
